import './StatisticsCard.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { Text, RichText } from '@sitecore-jss/sitecore-jss-react';
const StatisticsCard = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const isDetSite = props.isDetSite || false;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isDetSite: isDetSite
  }, /*#__PURE__*/React.createElement("article", {
    className: "statistics-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: `statistics-card__header-wrapper ${props.compactHeader ? "statistics-card__header-wrapper--compact" : ""}`
  }, /*#__PURE__*/React.createElement(Text, {
    className: "statistics-card__value",
    tag: "div",
    field: props.value
  }), /*#__PURE__*/React.createElement(Text, {
    className: "statistics-card__title",
    tag: "h1",
    field: props.title
  })), /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "statistics-card__description",
    field: props.description
  })));
};
export default StatisticsCard;
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    isDetSite
  } = _ref;
  const commonStyles = isDetSite ? "c1akefqg" : "c1o6zcwr";
  const ltrStyles = isDetSite ? "lbc5aqn" : "l1k7a99z";
  const rtlStyles = isDetSite ? "r164y3tn" : "r18p7y3g";
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};